<template>
  <v-row no-gutters>

   <customer-list v-if="userData.role === 'PLSYR' && $vuetify.breakpoint.xsOnly" />
    <v-col v-if="customerRequired" class="delayEl">
      <CustomerAlert />
    </v-col>
    <v-col v-else>
      <div
        id="tracking-list"
        :class="{ 'page-fullscreen': pageStore.isFullScreen }"
      >
        <v-card
          tile
          :class="$vuetify.breakpoint.smAndDown ? 'rounded-xl' : 'rounded-t-xl'"
        >
          <PageHeader>
            <template #action>
              <v-btn
                @click="downloadTable()"
                :color="$vuetify.breakpoint.mdAndDown ? 'accent' : 'accent'"
                class="text-capitalize"
                :class="{
                  'rounded-0 rounded-l-pill': $vuetify.breakpoint.mdAndDown,
                }"
                rounded
                depressed
                :loading="loadingDownload"
                >İndir</v-btn
              >
            </template>
          </PageHeader>
          <v-data-table
            loader-height="2"
            :headers="tableColumns"
            :items="tableItems"
            :loading="tableLoading"
            :height="pageStore.tableHeight"
            :options.sync="tableOptions"
            :server-items-length="tableTotalRec"
            :disable-items-per-page="true"
            :mobile-breakpoint="100"
            :items-per-page="20"
            fixed-header
            hide-default-footer
          >
            <!-- Load More -->
            <template v-slot:[`body.append`] v-if="loadMoreLoading">
              <tr>
                <td :colspan="tableColumns.length">
                  <div class="text-center" v-intersect.quiet="loadMore">
                    <v-progress-circular
                      v-if="tableItems.length > 0"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </td>
              </tr>
            </template>

            <!-- Arama Alanı -->
            <template v-slot:[`body.prepend`]>
              <tr class="data-table-body-search">
                <!-- Sipariş Durum -->
                <td class="pa-0">
                  <v-select
                    v-model="tableSearchOrderStatus"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="[
                      { text: 'işleniyor', value: 'null' },
                      { text: 'Başarılı', value: 'string' },
                      { text: 'Kısmi', value: 'PARTIAL' },
                      { text: 'Hata', value: 'ERR' },
                    ]"
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  />
                </td>

                <!-- Sipariş Tip -->
                <td class="pa-0">
                  <v-select
                    v-model="tableSearchMattype"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    :items="[
                      { text: 'Mamul', value: 'MAMUL' },
                      { text: 'Sarf', value: 'SARF' },
                    ]"
                    placeholder="Ara"
                    filled
                    clearable
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  />
                </td>

                <!-- Sipariş No -->
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchOrderNo"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <!-- Cari Bilgileri -->
                <!-- <td class="pa-0">
                  <v-autocomplete
                    v-if="userData.role === 'SUPER'"
                    placeholder="Ara"
                    class="rounded-0 elevation-0"
                    v-model="tableSearchCustomer"
                    :items="tableSearchCustomerItems"
                    :filter="tableSearchCustomerFilter"
                    :loading="tableSearchCustomerLoading"
                    item-text="name1"
                    item-value="customer"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    filled
                    clearable
                    hide-details
                    attach
                  >
                    <template v-slot:item="data">
                      <v-row align="center" dense>
                        <v-col cols="4">
                          <v-chip
                            color="secondary"
                            label
                            class="d-flex justify-center text-caption"
                          >
                            {{ data.item.customer }}
                          </v-chip></v-col
                        >
                        <v-col cols="8">
                          <div
                            class="text-caption text-truncate"
                            style="max-width: 500px"
                          >
                            {{ data.item.name1 }}
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                  <v-text-field
                    v-else
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td> -->

                <!-- Boş -->
                <td class="pa-0" v-for="(item, i) in tableEmptySearch" :key="i">
                  <v-text-field
                    filled
                    disabled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>
              </tr>
            </template>

            <!-- Sipariş Tipi -->
            <template #[`item.mattype`]="{ item }">
              <v-chip
                :color="
                  item.mattype === 'MAMUL'
                    ? 'secondary'
                    : item.mattype === 'SARF'
                    ? '#1f6388'
                    : 'error'
                "
                label
                class="d-flex justify-center text-caption"
                style="
                  font-size: 11px !important;
                  letter-spacing: 1.5px;
                  color: azure;
                "
              >
                {{ item.mattype || "BELİRSİZ" }}
              </v-chip>
            </template>

            <!-- Sipariş durum -->
            <template #[`item.order_status_text`]="{ item }">
              <v-alert
                class="ma-0"
                style="padding: 6px 0"
                :color="item.order_status"
                text
                outlined
              >
                <v-tooltip right :color="item.order_status">
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-bind="attrs"
                      v-on="on"
                      class="text-center text-caption"
                      style="font-size: 11px !important; letter-spacing: 1.5px"
                    >
                      {{ item.order_status_text }}
                    </div>
                  </template>
                  <div class="pa-1 text-subtitle-2 font-weight-bold">
                    {{ item.order_msg }}
                  </div>
                </v-tooltip>
              </v-alert>
            </template>

            <!-- Sipariş Numarası -->
            <template #[`item.order_no`]="{ item }">
              <v-chip
                label
                :color="item.order_no === 'HATA' ? 'error' : 'grey'"
                class="d-flex justify-center text-caption"
              >
                <span
                  class="text-caption text-xl-subtitle-2"
                  style="letter-spacing: 0.5px; color: azure"
                  >{{ item.order_no }}</span
                >
              </v-chip>
            </template>

            <!-- Sipariş Başlık -->
            <template #[`item.customer_name`]="{ item }">
              <div class="text-truncate" style="max-width: 500px !important">
                <div class="text-caption text-lg-subtitle-2 white--text">
                  {{ item.customer_name }}
                </div>
                <div
                  class="primary--text"
                  style="font-size: 10px !important; line-height: 1.5"
                >
                  {{ item.customer_username }} {{ item.cari_kod }}
                </div>
              </div>
            </template>

            <!-- Sipariş Tarihi -->
            <template #[`item.siparis_tarihi`]="{ item }">
              <v-tooltip color="chip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    color=""
                    class="d-flex justify-center"
                    label
                    v-bind="attrs"
                    v-on="on"
                  >
                    <div
                      class="text-truncate d-flex align-center"
                      style="
                        width: 130px !important;
                        text-align: center;
                        font-size: 11px !important;
                        letter-spacing: 0.5px;
                        color: azure;
                      "
                    >
                      <v-icon color="" small class="mr-2">
                        {{ icons.mdiCalendarClock }}
                      </v-icon>
                      <div class="mr-1">
                        {{ item.siparis_tarihi | moment("DD.MM.YYYY ") }}
                      </div>

                      <span>
                        - {{ item.siparis_tarihi | moment("HH:mm") }}</span
                      >
                    </div>
                  </v-chip>
                </template>
                <div>
                  {{ item.siparis_tarihi | moment("DD MMMM dddd") }}
                </div>
              </v-tooltip>
            </template>

            <!-- Tutar -->
            <template #[`item.total_price`]="{ item }">
              <div
                v-if="item.total_price"
                class="text-caption white--text font-weight-medium"
              >
                {{ item.total_price | currency({ symbol: "" }) }}
              </div>
            </template>

            <!-- Kalem Sayısı -->
            <template #[`item.kalem_sayisi`]="{ item }">
              <v-chip
                color="#9391a2"
                outlined
                class="d-flex justify-center"
                label
              >
                <div
                  class="text-capitalize"
                  style="text-align: center; font-size: 11px !important"
                >
                  {{ item.kalem_sayisi }} Adet
                </div>
              </v-chip>
            </template>

            <!-- Görüntüle -->
            <template #[`item.actions`]="{ item }">
              <v-btn
                depressed
                style="height: 32px !important"
                color="chip"
                block
                class="text-capitalize"
                @click="viewOrderAction(item)"
              >
                Görüntüle
              </v-btn>
            </template>
          </v-data-table>

          <order-tracking-view
            v-if="orderTrackingStore.viewDialogModel"
            @deleteItem="deleteItem"
          />
        </v-card>
      </div>
    <!--   <div v-else>
        <customer-list v-if="userData.role === 'PLSYR' && $vuetify.breakpoint.xsOnly" />
        <v-alert
          text
          outlined
          class="mx-3 mx-lg-0 rounded-pill mt-2 mt-md-0 text-caption"
          type="warning"
        >
          Lütfen yukarıdan bir müşteri seçin
        </v-alert>
      </div> -->
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
import store from "@/store";
import { useRouter } from "@core/utils";
import { ref, watch, onMounted, onUnmounted, computed } from "vue-demi";
import CustomerList from "@/components/CustomerList.vue";
// Pinia
import { useAppStore } from "@/stores/app";
import { usePageStore } from "@/stores/pageHeader";
import { useOrderTrackingStore } from "./../_orderTrackingStore";

// Utils
import { postData } from "@utils";
import { useDebounceFn } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";

// Component
import PageHeader from "@/components/PageHeader/Index.vue";
import OrderTrackingView from "./View.vue";
import CustomerAlert from "@/components/CustomerAlert.vue";
// Icons
import {
  mdiCheck,
  mdiCalendarClock,
  mdiOrderNumericAscending,
  mdiMagnify,
  mdiDownload,
  mdiDelete,
} from "@mdi/js";

export default {
  components: {
    PageHeader,
    OrderTrackingView,
    CustomerAlert,
    CustomerList
  },

  setup() {
    const appStore = useAppStore();
    const pageStore = usePageStore();
    const userData = JSON.parse(localStorage.getItem("userData"));

    // SUPER rolü müşteri seçmeden tüm müşterilerin siparişlerini görür
    const customerRequired = computed(
      () => appStore.isCustomer && userData.role !== "SUPER"
    );

    // Sayfa Özellikleri
    const pageSettings = () => {
      pageStore.pageTitle = "Sipariş Takip";
      pageStore.pageIcon = mdiOrderNumericAscending;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = false;
      pageStore.hasDateRangeAll = false;
      pageStore.hasDateRange = false;
      pageStore.hasActions = true;

      pageStore.downloadHeader = {
        "Sipariş Tipi": "mattype",
        "Sipariş No": "order_no",
        "Cari Bilgileri": "customer_name",
        "Tutar (TL)": "total_price",
        Kalem: "kalem_sayisi",
        Tarih: "siparis_tarihi",
      };
    };

    const { route } = useRouter();
    // Kullanıcı verileri
    const orderTrackingStore = useOrderTrackingStore();
    const toast = useToast();

    // Table
    const tableLoading = ref(true);
    const tableItems = ref([]);
    const tableTotalRec = ref(0);

    // Table Columns
    const tableColumns = ref([
      {
        text: "Durum",
        value: "order_status_text",
        align: "left px-4 px-lg-3",
        width: 130,
        sortable: false,
      },
      {
        text: "Sipariş Tipi",
        value: "mattype",
        width: 150,
        align: "left pl-0 pr-3 px-lg-3",
        sortable: false,
      },

      {
        text: "Sipariş No",
        value: "order_no",
        align: "left pl-0 pr-3 px-lg-3 width-120-220",
        sortable: false,
      },

      {
        text: "Cari Bilgileri",
        value: "customer_name",
        align: "left min-width-400 pl-0 pr-3 px-lg-3",
        sortable: false,
      },
      {
        text: "Tutar (TL)",
        align: "right pl-0 pr-3 px-lg-3",
        value: "total_price",
        width: "100",
        sortable: false,
      },

      {
        text: "Kalem",
        align: "center pl-0 pr-3 px-lg-3",
        value: "kalem_sayisi",
        width: "80px",
        sortable: false,
      },
      {
        text: "Tarihi",
        align: "center pl-0 pr-3 px-lg-3",
        value: "siparis_tarihi",
        width: "130px",
        sortable: false,
      },
      {
        text: "",
        align: "right px-3",
        value: "actions",
        width: "80px",
        sortable: false,
      },
    ]);

    // Table Load More
    const tablePage = ref(1);
    const loadMoreLoading = ref(false);
    const loadMore = (isIntersecting) => {
      if (isIntersecting) {
        tablePage.value++;
        tableOptions.value.page = tablePage.value;
        if (!tableLoading.value) {
          tableFetch();
        }
      }
    };

    // Tablo Arama
    const tableSearchMattype = ref("");
    const tableSearchOrderStatus = ref("");
    const tableSearchOrderNo = ref("");
    const tableSearchCustomer = ref("");
    const tableEmptySearch = ref(5);
    const tableOptions = ref({
      sortBy: ["id"],
      sortDesc: [true],
    });

    // Cari bilgi arama
    const tableSearchCustomerFilter = (item, queryText, itemText) =>
      item.customer.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
        -1 ||
      item.name1.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
        -1;

    const tableSearchCustomerItems = ref([]);
    const tableSearchCustomerLoading = ref(false);

    const customerFetch = () => {
      tableSearchCustomerLoading.value = true;

      const data = {
        method: "getCustomersBySalDept",
        type: "select",
      };
      store
        .dispatch("postMethod", data)
        .then((response) => {
          tableSearchCustomerItems.value = response.detail;
        })
        .catch((e) => {
          Vue.swal({
            title: "Hata",
            text: e.message,
            width: "350px",
            icon: "error",
            background: "#FF4C51",
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: "#cc3d41",
          });
        })
        .finally(() => {
          tableSearchCustomerLoading.value = false;
        });
    };

    const debouncedTableSearch = useDebounceFn(() => {
      tableFetch();
    }, 700);

    watch(
      [
        tableSearchMattype,
        tableSearchOrderStatus,
        tableSearchOrderNo,
        tableSearchCustomer,
      ],
      () => {
        loadMoreLoading.value = false;
        tableLoading.value = true;
        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];

        debouncedTableSearch();
      }
    );

    // Untils
    const usernameFind = (text) => {
      let result;
      if (typeof text === "string") {
        if (text.split(" / ").length > 1) {
          result = text.split(" / ")[1];
        } else if (text.split("(").length > 1) {
          result = text.split("(")[1].slice(0, -1);
        } else {
          result = "TANIMSIZ";
        }
      } else {
        result = "TANIMSIZ";
      }
      return result + " - ";
    };

    const customerFind = (text) => {
      let result;
      if (typeof text === "string") {
        if (text.split(" / ").length > 1) {
          result = text.split(" / ")[0];
        } else {
          result = text.split("(")[0];
        }
      }
      return result
        ?.toLowerCase()
        .replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());
    };

    // API İstek
    const tableFetch = () => {
      if (customerRequired.value) {
        tableLoading.value = false;
        return;
      }

      tableLoading.value = true;
      const searchCustomer = appStore.selectedCustomer || tableSearchCustomer.value;

      postData({
        method: "getSales",
        options: JSON.stringify(tableOptions.value),
        search: JSON.stringify({
          erporderno: tableSearchOrderNo.value,
          ordermattype: tableSearchMattype.value,
          status: tableSearchOrderStatus.value,
          cari_kod: searchCustomer,
        }),
      })
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            throw new Error(response.msg);
          }

          // Toplam kayıt sayısı işleniyor
          tableTotalRec.value = Number(response.response.pagination.totalCount);

          // API'dan gelen veriler işleniyor

          // Responseda bir değer yoksa
          if (response.response.result.length === 0) {
            loadMoreLoading.value = false;
            return;
          }

          // Responsedan gelen veriler işleniyor
          response.response.result.map((item) => {
            tableItems.value.push({
              mattype: item.mattype,
              order_no:
                userData.role === "SUPER" ||
                userData.role === "COMMAN" ||
                userData.role === "COMM" ||
                userData.role === "COMUSR"
                  ? item.erporderno == "ERR" || item.erporderno === null
                    ? item.id
                    : item.erporderno
                  : item.id,
              order_status_text:
                item.erporderno == "ERR"
                  ? "HATALI"
                  : item.erporderno === null
                  ? "İŞLENİYOR"
                  : item.erporderno == "PARTIAL"
                  ? "KISMİ"
                  : "BAŞARILI",
              order_status:
                item.erporderno == "ERR"
                  ? "error"
                  : item.erporderno === null
                  ? "warning"
                  : item.erporderno == "PARTIAL"
                  ? "info"
                  : "success",
              order_msg:
                item.erporderno == "ERR"
                  ? item.erpmsg || "Sistem yöneticiniz ile iletişime geçin"
                  : item.erporderno === null
                  ? "Siparişiniz sistem tarafından işleniyor"
                     : item.erporderno == "PARTIAL"
                  ? "Siparişiniz kısmi durumda"
                  : "Siparişiniz başarılı bir şekilde alındı",
              cari_kod: item.cari_kod,
              customer_name: customerFind(item.customer_name),
              customer_username: usernameFind(item.customer_name),
              durum_color: item.durum_color || "warning",
              siparis_tarihi: item.siparis_tarihi,
              total_price: item.total_price,
              id: item.id,
              kalem_sayisi: item.products.length,
              products: item.products,
              teslim_tarihi: item.teslim_tarihi,
              buyer_note: item.buyer_note,
              actions: null,
            });
          });
          loadMoreLoading.value = false;
          if (tableTotalRec.value >= 20) {
            setTimeout(() => {
              loadMoreLoading.value = true;
            }, 300);
          }
          // Responstan gelen verilere göre loadmore değerlendiriliyor
        })
        .catch((e) => {
          // API hataya girdi
          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          tableLoading.value = false;
          startPage.value = false;
        });
    };

    const deleteItem = async () => {
      Vue.swal({
        title: "Emin misin",
        html: `<strong>"${orderTrackingStore.viewDialogData.id}"</strong><br>siparişi silinsin mi`,
        icon: "warning",
        width: "350px",
        background: "#FF4C51",
        showCancelButton: true,
        confirmButtonColor: "#cc3d41",
        confirmButtonText: "Evet",
        cancelButtonText: "Vazgeç",
        cancelButtonColor: "#FF4C51",
      }).then(async (result) => {
        if (result.isConfirmed) {
          orderTrackingStore.viewDialogLoading = true;
          orderTrackingStore.deleteLoading = true;
          try {
            const response = await postData({
              method: "deleteSale",
              id: orderTrackingStore.viewDialogData.id,
            });
            if (response.error) {
              throw new Error(response.msg);
            }
            toast.warning(
              `"${orderTrackingStore.viewDialogData.id}" siparişi silindi`
            );
            //  tableFetch();

            tableItems.value.splice(
              tableItems.value.indexOf(orderTrackingStore.viewDialogData),
              1
            );
          } catch (e) {
            toast.error(`Hata ${e}`, { position: "bottom-center" });
          } finally {
            orderTrackingStore.viewDialogClose();
          }
        }
      });
    };

    const loadingDownload = ref(false);
    const downloadTable = async () => {
      loadingDownload.value = true;
      postData({
        method: "getOrderAndLinesToExcel",
      }).then((response) => {
        if (response.error === 0) {
          window.open(response.file, "_blank");
        }
        loadingDownload.value = false;
      });
    };

    const viewOrderAction = (data) => {
      orderTrackingStore.viewDialogData = data;
      orderTrackingStore.viewDialogModel = true;
    };

    const startPage = ref(false);
    onMounted(() => {
      pageSettings();
      if (customerRequired.value) {
        tableLoading.value = false;
        return;
      }
      if (userData.role === "SUPER") {
        customerFetch();
      }
      startPage.value = true;
      tableFetch();
    });


    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });

     // İç sayfa değişimi izleniyor
     watch(
      () => route.value.params.folder,
      () => {
        store.documentFind(route.value.params.folder);
        pageStore.pageTitle = store.documentType.title;
        if (!customerRequired.value) {
          store.tableSearch_1 = store.tableSearch_2 = "";
          store.tableColumnsFn(route.value.params.folder);
          store.tableFetch(pageStore.dateRange);
        }
      }
    );

 // Müşteri seçimi gerekiyorsa değişiklikler izleniyor

    watch(
      () => appStore.selectedCustomer,
      (val) => {
        if (customerRequired.value) {
          tableItems.value = [];
          tableTotalRec.value = 0;
          tableLoading.value = false;
          return;
        }

        tablePage.value = 1;
        tableOptions.value.page = 1;
        tableItems.value = [];
        tableLoading.value = true;
        tableFetch();
      }
    );

    return {
      // Utils
      userData,
      pageStore,
      orderTrackingStore,
      customerFetch,
      loadingDownload,

      // Table
      tableFetch,
      tableColumns,
      tableItems,
      tableLoading,
      loadMore,
      loadMoreLoading,
      tableTotalRec,
      tableEmptySearch,
      tableOptions,

      // Table Search
      tableSearchMattype,
      tableSearchOrderStatus,
      tableSearchOrderNo,
      tableSearchCustomer,
      tableSearchCustomerFilter,
      tableSearchCustomerItems,
      tableSearchCustomerLoading,

      // API
      deleteItem,

      // Actions
      downloadTable,
      viewOrderAction,
      appStore,
      customerRequired,
      // Icons
      icons: {
        mdiCheck,
        mdiOrderNumericAscending,
        mdiMagnify,
        mdiDownload,
        mdiDelete,
        mdiCalendarClock,
      },
    };
  },
};
</script>
